import React, { useState, useEffect } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Collapse from "@mui/material/Collapse";
import IconExpandLess from "@mui/icons-material/ExpandLess";
import IconExpandMore from "@mui/icons-material/ExpandMore";
import { sideNavImg } from "../../assets";
import { useNavigate } from "react-router-dom";
import NoteIcon from "@mui/icons-material/Note";

import {
  DASHBOARD,
  SUPPORT,
  OBSERVATION,
  REPRIMAND,
  INCIDENT_LIST,
  VIEW_INSPECTION_REPORT,
  REPRIMAND_LIST,
  CREATE_LESSON,
  CREATE_COURSE,
  OPEN_ITEMS_LIST,
  VIEW_OBSERVATION_LISTS,
  ADMIN_SAFETY_LOG,
  INSPECTION_ADMIN,
  ADMIN_CLIENT_LIST,
  ADMIN_UTILITY,
  ADMIN_COMPANY_MANAGEMENT,
  ADMIN_USER_MANAGEMENT,
  ADMIN_ASSET_MANAGEMENT,
  ADMIN_CREDENTIAL_MANAGEMENT,
  ADMIN_RESOURCE,
  ADDCASE,
  CASES,
  TOOL_BOX_LIST,
  ADMIN_CONTRACTOR_MANAGEMENT,
  ADMIN_CONTRACTOR_DETAILS,
  TOOL_BOX_USER,
  SW_INSPECTION_CONFIGURATION,
  ADMIN_JHA_CONFIGURATION,
  SW_INSPECTION_LIST,
  CONDUCT_JHA,
  CONDUCT_JHA_LIST,
  SW_OPEN_ITEMS,
  SWDASHBOARD,
  ADMIN_PROJECTS_LIST,
  ADMIN_SITE_PROJECTS_LIST,
  SW_INSPECTION_ADD,
  SW_INSPECTION_DAILY_VIEW,
  SW_REPORTS_ANALYTICS,
  ADD_INSPECTION_NEW,
  OSHA_VIEW_REPORT_LIST,
  OSHA_RECORDKEEPING,
  OSHA_ITASUBMISSION,
  REPORTS_ANALYTICS_DASHBOARD,
  LESSON,
  USERLESSON,
  LMS_MARKET,
} from "../../constant/routeContant";
import "./sidebar.scss";
import { logos } from "../../assets";
import { checkPrivileges, showRighSideMenu } from "../../utils/rolesHelper";
import { HBNEXT_ORG_ID, ORG_ID, DARK } from "../../constant/constant";
import { useThemeContext } from "../../context";
import { InactiveClient, getUserBaseDivisionInfo } from "../../utils/helper";
import { useSelector } from "react-redux";

const AppMenu = ({ handleRoute, location }) => {
  const navigate = useNavigate();
  const [inspection, setInspection] = React.useState(false);
  const [swInspection, setSwInspection] = React.useState(false);
  const [admin, setAdmin] = React.useState(false);
  const [oshaManagement, setOshaManagement] = React.useState(false);
  const [incident, setIncident] = React.useState(false);
  const [openItem, setOpenItem] = React.useState(false);
  const [training, setTraining] = React.useState(false);
  const [jhaReports, setJHAReports] = React.useState(false);
  const [activeClass, setActiveClass] = useState();
  const { mode } = useThemeContext();
  const isAuth = useSelector((state) => state.login.userSuccess);
  useEffect(() => {
    document.body.className = mode === "light" ? "light-mode" : "dark-mode";
  }, [mode]);
  const showMenu = showRighSideMenu();
  const { hasBaseDivisionAdminAccess } = getUserBaseDivisionInfo();

  const siteURL =
    checkPrivileges([12, 111, 112, 113]) &&
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID)
      ? ADMIN_PROJECTS_LIST
      : checkPrivileges([12, 108, 109, 110, 111, 112, 113])
        ? ADMIN_PROJECTS_LIST
        : (parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) &&
              checkPrivileges([108, 109, 110])) ||
            checkPrivileges([108, 109, 110])
          ? ADMIN_SITE_PROJECTS_LIST
          : ADMIN_PROJECTS_LIST;

  const onRouteChange = (url) => {
    handleRoute(url);
    setActiveClass({ active: url });
  };
  const userInfoDetails = JSON.parse(localStorage.getItem("userInfo"));

  useEffect(() => {
    if (location?.pathname) {
      setActiveClass({ active: location?.pathname });
    }
  }, [location]);

  const handleProtectedToggle = (flag, setFlag) => {
    const token = localStorage.getItem("id_token");
    if (!token || !isAuth) {
      navigate("/login", { replace: true });
      return;
    }
    setFlag(!flag);
  };

  return (
    <>
      <div className="logo">
        {mode === DARK ? (
          <img src={logos?.logoWhite} width="110px" alt="no logo" />
        ) : (
          <img src={logos?.logo} width="110px" alt="no logo" />
        )}
      </div>
      <List component="nav" className="appMenu" disablePadding>
        {/* Dashboard swdahsboard*/}
        <ListItem
          button
          className={
            activeClass?.active === DASHBOARD
              ? "menuItem activeClass"
              : "menuItem"
          }
          onClick={() =>
            onRouteChange(showMenu?.isSW ? SWDASHBOARD : DASHBOARD)
          }
        >
          <ListItemIcon className={"menuItemIcon"}>
            <svg
              width="20"
              height="24"
              viewBox="0 0 20 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 23.25V8.25L10 0.75L20 8.25V23.25H12.5V14.5H7.5V23.25H0Z" />
            </svg>
          </ListItemIcon>
          <ListItemText className="menuText" primary="Dashboard" />
        </ListItem>
        {/* Admin */}
        {checkPrivileges([
          11, 12, 13, 37, 38, 39, 40, 41, 42, 43, 44, 45, 47, 48, 49, 50, 51,
          52, 53, 54, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
          72, 73, 74, 78, 79, 80, 93, 94, 95, 99, 100, 101, 108, 109, 110, 111,
          112, 113, 120, 121, 122, 123, 1, 2, 14, 55, 56, 57, 76, 77, 7, 96, 97,
          98, 126, 127, 148, 151, 152, 153, 154,
        ]) && (
          <ListItem
            button
            onClick={() => handleProtectedToggle(admin, setAdmin)}
            className={"menuItem"}
          >
            <ListItemIcon className={"menuItemIcon"}>
              <svg
                width="26"
                height="25"
                viewBox="0 0 26 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M3.25 23C2.5625 23 1.97375 22.7554 1.48375 22.2663C0.994583 21.7763 0.75 21.1875 0.75 20.5V3C0.75 2.3125 0.994583 1.72375 1.48375 1.23375C1.97375 0.744583 2.5625 0.5 3.25 0.5H20.75C21.4375 0.5 22.0263 0.744583 22.5163 1.23375C23.0054 1.72375 23.25 2.3125 23.25 3V10.0938C22.6667 9.80208 22.0575 9.58833 21.4225 9.4525C20.7867 9.3175 20.1458 9.25 19.5 9.25C18.8958 9.25 18.3229 9.30708 17.7813 9.42125C17.2396 9.53625 16.7083 9.69792 16.1875 9.90625C16.25 9.69792 16.2971 9.48958 16.3288 9.28125C16.3596 9.07292 16.375 8.85417 16.375 8.625C16.375 7.41667 15.9479 6.38542 15.0938 5.53125C14.2396 4.67708 13.2083 4.25 12 4.25C10.7917 4.25 9.76042 4.67708 8.90625 5.53125C8.05208 6.38542 7.625 7.41667 7.625 8.625C7.625 9.83333 8.05208 10.8646 8.90625 11.7188C9.76042 12.5729 10.7917 13 12 13H12.3125C12.0417 13.375 11.8075 13.7758 11.61 14.2025C11.4117 14.63 11.2396 15.0729 11.0938 15.5312C9.55208 15.6354 8.12 16 6.7975 16.625C5.47417 17.25 4.29167 18.0625 3.25 19.0625V20.5H11.125C11.2708 20.9583 11.4375 21.3958 11.625 21.8125C11.8125 22.2292 12.0417 22.625 12.3125 23H3.25ZM18.25 24.25L17.875 22.375C17.625 22.2708 17.3908 22.1617 17.1725 22.0475C16.9533 21.9325 16.7292 21.7917 16.5 21.625L14.6875 22.1875L13.4375 20.0625L14.875 18.8125C14.8333 18.5208 14.8125 18.25 14.8125 18C14.8125 17.75 14.8333 17.4792 14.875 17.1875L13.4375 15.9375L14.6875 13.8125L16.5 14.375C16.7292 14.2083 16.9533 14.0675 17.1725 13.9525C17.3908 13.8383 17.625 13.7292 17.875 13.625L18.25 11.75H20.75L21.125 13.625C21.375 13.7292 21.6096 13.8437 21.8288 13.9688C22.0471 14.0938 22.2708 14.25 22.5 14.4375L24.3125 13.8125L25.5625 16L24.125 17.25C24.1667 17.5 24.1875 17.7604 24.1875 18.0312C24.1875 18.3021 24.1667 18.5625 24.125 18.8125L25.5625 20.0625L24.3125 22.1875L22.5 21.625C22.2708 21.7917 22.0471 21.9325 21.8288 22.0475C21.6096 22.1617 21.375 22.2708 21.125 22.375L20.75 24.25H18.25ZM19.5 20.5C20.1875 20.5 20.7763 20.2554 21.2663 19.7663C21.7554 19.2763 22 18.6875 22 18C22 17.3125 21.7554 16.7237 21.2663 16.2337C20.7763 15.7446 20.1875 15.5 19.5 15.5C18.8125 15.5 18.2238 15.7446 17.7338 16.2337C17.2446 16.7237 17 17.3125 17 18C17 18.6875 17.2446 19.2763 17.7338 19.7663C18.2238 20.2554 18.8125 20.5 19.5 20.5Z" />
              </svg>
            </ListItemIcon>
            <ListItemText className="menuText" primary="Admin" />
            {admin ? (
              <IconExpandLess className="menuIcon" />
            ) : (
              <IconExpandMore className="menuIcon" />
            )}
          </ListItem>
        )}
        <Collapse in={admin} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" disablePadding>
            {checkPrivileges([12, 67, 68]) && (
              <ListItem
                button
                className={
                  activeClass?.active === ADMIN_CLIENT_LIST
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(ADMIN_CLIENT_LIST)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="Client Management"
                />
              </ListItem>
            )}
            {showMenu?.isSW &&
              checkPrivileges([111, 112, 113, 108, 109, 110, 12]) && (
                <ListItem
                  button
                  className={
                    activeClass?.active === siteURL
                      ? "menuItem activeClass"
                      : "menuItem"
                  }
                  onClick={() => onRouteChange(siteURL)}
                >
                  <ListItemText
                    className="menuSubText"
                    inset
                    primary="Site Management"
                  />
                </ListItem>
              )}

            {checkPrivileges([40, 41, 42, 49, 50, 51, 73, 12]) && (
              <ListItem
                button
                className={
                  activeClass?.active === ADMIN_COMPANY_MANAGEMENT
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(ADMIN_COMPANY_MANAGEMENT)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="Company Management"
                />
              </ListItem>
            )}

            {checkPrivileges([12, 55, 56, 57, 64, 65, 66, 77, 76, 14, 148]) && (
              <ListItem
                button
                className={
                  activeClass?.active === ADMIN_USER_MANAGEMENT
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(ADMIN_USER_MANAGEMENT)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="User Management"
                />
              </ListItem>
            )}

            {showMenu?.isSafety &&
              checkPrivileges([
                12, 37, 38, 39, 52, 53, 54, 70, 71, 72, 78, 79, 80,
              ]) && (
                <ListItem
                  button
                  className={
                    activeClass?.active === ADMIN_ASSET_MANAGEMENT
                      ? "menuItem activeClass"
                      : "menuItem"
                  }
                  onClick={() => onRouteChange(ADMIN_ASSET_MANAGEMENT)}
                >
                  <ListItemText
                    className="menuSubText"
                    inset
                    primary="Asset Management"
                  />
                </ListItem>
              )}

            {checkPrivileges([12, 13, 47, 48]) && (
              <ListItem
                button
                data-testid="sidebar-admin-credential"
                className={
                  activeClass?.active === ADMIN_CREDENTIAL_MANAGEMENT
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(ADMIN_CREDENTIAL_MANAGEMENT)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="Credential Management"
                />
              </ListItem>
            )}

            {checkPrivileges([
              12, 1, 2, 151, 4, 11, 90, 7, 64, 78, 52, 43, 37, 13, 44, 73, 126,
            ]) &&
              !hasBaseDivisionAdminAccess && (
                <ListItem
                  button
                  data-testid="sidebar-admin-config"
                  className={
                    activeClass?.active === ADMIN_UTILITY
                      ? "menuItem activeClass"
                      : "menuItem"
                  }
                  onClick={() => onRouteChange(ADMIN_UTILITY)}
                >
                  <ListItemText
                    className="menuSubText"
                    inset
                    primary="Configuration Management"
                  />
                </ListItem>
              )}

            {showMenu?.isSafety && checkPrivileges([12, 120, 121, 122]) && (
              <ListItem
                button
                className={
                  activeClass?.active === INSPECTION_ADMIN
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(INSPECTION_ADMIN)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="Inspection Management"
                />
              </ListItem>
            )}

            {showMenu?.isSW &&
              checkPrivileges([12, 93, 94, 95, 96, 97, 98, 99, 100, 101]) && (
                <ListItem
                  button
                  className={
                    activeClass?.active === SW_INSPECTION_CONFIGURATION
                      ? "menuItem activeClass"
                      : "menuItem"
                  }
                  onClick={() => onRouteChange(SW_INSPECTION_CONFIGURATION)}
                >
                  <ListItemText
                    className="menuSubText"
                    inset
                    primary="Inspection Management"
                  />
                </ListItem>
              )}

            {showMenu?.isSafety && checkPrivileges([12, 43, 44, 45]) && (
              <ListItem
                button
                className={
                  activeClass?.active === ADMIN_CONTRACTOR_MANAGEMENT
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(ADMIN_CONTRACTOR_MANAGEMENT)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="Contractor Management"
                />
              </ListItem>
            )}

            {showMenu?.isSafety &&
              checkPrivileges([12, 58, 59, 60, 61, 62, 63]) && (
                <ListItem
                  button
                  className={
                    activeClass?.active === ADMIN_JHA_CONFIGURATION
                      ? "menuItem activeClass"
                      : "menuItem"
                  }
                  onClick={() => onRouteChange(ADMIN_JHA_CONFIGURATION)}
                >
                  <ListItemText
                    className="menuSubText"
                    inset
                    primary="Hazard Analysis Configuration"
                  />
                </ListItem>
              )}
          </List>
        </Collapse>

        {/* inspection */}
        {showMenu?.isSafety && checkPrivileges([12, 16, 4, 5, 6]) && (
          <ListItem
            button
            onClick={() => handleProtectedToggle(inspection, setInspection)}
            className={"menuItem"}
          >
            <ListItemIcon className={"menuItemIcon"}>
              <svg
                width="20"
                height="26"
                viewBox="0 0 20 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10 16.75C10.6875 16.75 11.2762 16.505 11.7663 16.015C12.2554 15.5258 12.5 14.9375 12.5 14.25C12.5 13.5625 12.2554 12.9738 11.7663 12.4837C11.2762 11.9946 10.6875 11.75 10 11.75C9.3125 11.75 8.72417 11.9946 8.235 12.4837C7.745 12.9738 7.5 13.5625 7.5 14.25C7.5 14.9375 7.745 15.5258 8.235 16.015C8.72417 16.505 9.3125 16.75 10 16.75ZM2.5 25.5C1.8125 25.5 1.22417 25.2554 0.735 24.7663C0.245 24.2763 0 23.6875 0 23V3C0 2.3125 0.245 1.72375 0.735 1.23375C1.22417 0.744583 1.8125 0.5 2.5 0.5H13.75L20 8V22.4688L14.2812 16.75C14.5104 16.3958 14.6875 16.0104 14.8125 15.5938C14.9375 15.1771 15 14.7292 15 14.25C15 12.875 14.5104 11.6979 13.5312 10.7188C12.5521 9.73958 11.375 9.25 10 9.25C8.625 9.25 7.44792 9.73958 6.46875 10.7188C5.48958 11.6979 5 12.875 5 14.25C5 15.625 5.48958 16.8021 6.46875 17.7812C7.44792 18.7604 8.625 19.25 10 19.25C10.4792 19.25 10.9325 19.1875 11.36 19.0625C11.7867 18.9375 12.1771 18.7604 12.5312 18.5312L19 25C18.8125 25.1667 18.5729 25.2917 18.2812 25.375C17.9896 25.4583 17.7292 25.5 17.5 25.5H2.5Z" />
              </svg>
            </ListItemIcon>
            <ListItemText className="menuText" primary="Inspections" />
            {inspection ? (
              <IconExpandLess className="menuIcon" />
            ) : (
              <IconExpandMore className="menuIcon" />
            )}
          </ListItem>
        )}
        <Collapse in={inspection} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" disablePadding>
            {checkPrivileges([12, 16, 4, 5]) && (
              <ListItem
                button
                className={
                  activeClass?.active === ADD_INSPECTION_NEW
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => {
                  if (InactiveClient()) return;
                  onRouteChange(ADD_INSPECTION_NEW);
                }}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="Add Report"
                />
              </ListItem>
            )}
            {checkPrivileges([12, 16, 4, 5, 6]) && (
              <ListItem
                button
                className={
                  activeClass?.active === VIEW_INSPECTION_REPORT
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(VIEW_INSPECTION_REPORT)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="View Reports"
                />
              </ListItem>
            )}
          </List>
        </Collapse>

        {/* sw inspection */}
        {showMenu?.isSW && checkPrivileges([12, 102, 103, 104]) && (
          <>
            <ListItem
              button
              onClick={() =>
                handleProtectedToggle(swInspection, setSwInspection)
              }
              className={"menuItem"}
            >
              <ListItemIcon className={"menuItemIcon"}>
                <svg
                  width="20"
                  height="26"
                  viewBox="0 0 20 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M10 16.75C10.6875 16.75 11.2762 16.505 11.7663 16.015C12.2554 15.5258 12.5 14.9375 12.5 14.25C12.5 13.5625 12.2554 12.9738 11.7663 12.4837C11.2762 11.9946 10.6875 11.75 10 11.75C9.3125 11.75 8.72417 11.9946 8.235 12.4837C7.745 12.9738 7.5 13.5625 7.5 14.25C7.5 14.9375 7.745 15.5258 8.235 16.015C8.72417 16.505 9.3125 16.75 10 16.75ZM2.5 25.5C1.8125 25.5 1.22417 25.2554 0.735 24.7663C0.245 24.2763 0 23.6875 0 23V3C0 2.3125 0.245 1.72375 0.735 1.23375C1.22417 0.744583 1.8125 0.5 2.5 0.5H13.75L20 8V22.4688L14.2812 16.75C14.5104 16.3958 14.6875 16.0104 14.8125 15.5938C14.9375 15.1771 15 14.7292 15 14.25C15 12.875 14.5104 11.6979 13.5312 10.7188C12.5521 9.73958 11.375 9.25 10 9.25C8.625 9.25 7.44792 9.73958 6.46875 10.7188C5.48958 11.6979 5 12.875 5 14.25C5 15.625 5.48958 16.8021 6.46875 17.7812C7.44792 18.7604 8.625 19.25 10 19.25C10.4792 19.25 10.9325 19.1875 11.36 19.0625C11.7867 18.9375 12.1771 18.7604 12.5312 18.5312L19 25C18.8125 25.1667 18.5729 25.2917 18.2812 25.375C17.9896 25.4583 17.7292 25.5 17.5 25.5H2.5Z" />
                </svg>
              </ListItemIcon>
              <ListItemText className="menuText" primary="Inspections" />
              {inspection ? (
                <IconExpandLess className="menuIcon" />
              ) : (
                <IconExpandMore className="menuIcon" />
              )}
            </ListItem>
            <Collapse in={swInspection} timeout="auto" unmountOnExit>
              <Divider />
              <List component="div" disablePadding>
                {checkPrivileges([12, 102, 103]) && (
                  <ListItem
                    button
                    className={
                      activeClass?.active === SW_INSPECTION_ADD
                        ? "menuItem activeClass"
                        : "menuItem"
                    }
                    onClick={() => {
                      if (InactiveClient()) return;
                      onRouteChange(SW_INSPECTION_ADD);
                    }}
                  >
                    <ListItemText
                      className="menuSubText"
                      inset
                      primary="Add Report"
                    />
                  </ListItem>
                )}
                {checkPrivileges([12, 102, 103, 104]) && (
                  <>
                    <ListItem
                      button
                      className={
                        activeClass?.active === SW_INSPECTION_LIST
                          ? "menuItem activeClass"
                          : "menuItem"
                      }
                      onClick={() => onRouteChange(SW_INSPECTION_LIST)}
                    >
                      <ListItemText
                        className="menuSubText"
                        inset
                        primary="View Reports"
                      />
                    </ListItem>
                    <ListItem
                      button
                      className={
                        activeClass?.active === SW_INSPECTION_DAILY_VIEW
                          ? "menuItem activeClass"
                          : "menuItem"
                      }
                      onClick={() => onRouteChange(SW_INSPECTION_DAILY_VIEW)}
                    >
                      <ListItemText
                        className="menuSubText"
                        inset
                        primary="View Daily Report"
                      />
                    </ListItem>
                  </>
                )}
              </List>
            </Collapse>
          </>
        )}

        {/* JHA inspection */}
        {showMenu?.isSafety && checkPrivileges([12, 123, 124, 125]) && (
          <ListItem
            button
            onClick={() => handleProtectedToggle(jhaReports, setJHAReports)}
            className={"menuItem"}
          >
            <ListItemIcon className={"menuItemIcon"}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5.75 18.25H8.25V9.5H5.75V18.25ZM10.75 18.25H13.25V5.75H10.75V18.25ZM15.75 18.25H18.25V13.25H15.75V18.25ZM3.25 23.25C2.5625 23.25 1.97375 23.0054 1.48375 22.5163C0.994583 22.0263 0.75 21.4375 0.75 20.75V3.25C0.75 2.5625 0.994583 1.97375 1.48375 1.48375C1.97375 0.994583 2.5625 0.75 3.25 0.75H20.75C21.4375 0.75 22.0263 0.994583 22.5163 1.48375C23.0054 1.97375 23.25 2.5625 23.25 3.25V20.75C23.25 21.4375 23.0054 22.0263 22.5163 22.5163C22.0263 23.0054 21.4375 23.25 20.75 23.25H3.25Z" />
              </svg>
            </ListItemIcon>
            <ListItemText className="menuText" primary="Hazard Analysis" />
            {jhaReports ? (
              <IconExpandLess className="menuIcon" />
            ) : (
              <IconExpandMore className="menuIcon" />
            )}
          </ListItem>
        )}
        <Collapse in={jhaReports} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" disablePadding>
            {showMenu?.isSafety && checkPrivileges([12, 123, 124]) && (
              <ListItem
                button
                className={
                  activeClass?.active === CONDUCT_JHA
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => {
                  if (InactiveClient()) return;
                  onRouteChange(CONDUCT_JHA);
                }}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="Add Hazard Analysis Report"
                />
              </ListItem>
            )}
            {checkPrivileges([12, 123, 124, 125]) && (
              <ListItem
                button
                className={
                  activeClass?.active === CONDUCT_JHA_LIST
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(CONDUCT_JHA_LIST)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="View Hazard Analysis Report"
                />
              </ListItem>
            )}
          </List>
        </Collapse>

        {/*incident */}
        {showMenu?.isSafety &&
          checkPrivileges([1, 2, 3, 12, 149, 150, 151]) && (
            <ListItem
              button
              onClick={() => handleProtectedToggle(incident, setIncident)}
              className={"menuItem"}
            >
              <ListItemIcon className={"menuItemIcon"}>
                <svg
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M20.5 12.75C18.7708 12.75 17.2971 12.1404 16.0788 10.9212C14.8596 9.70292 14.25 8.22917 14.25 6.5C14.25 4.77083 14.8596 3.29667 16.0788 2.0775C17.2971 0.859167 18.7708 0.25 20.5 0.25C22.2292 0.25 23.7033 0.859167 24.9225 2.0775C26.1408 3.29667 26.75 4.77083 26.75 6.5C26.75 8.22917 26.1408 9.70292 24.9225 10.9212C23.7033 12.1404 22.2292 12.75 20.5 12.75ZM19.875 7.75H21.125V2.75H19.875V7.75ZM20.5 10.25C20.6667 10.25 20.8125 10.1875 20.9375 10.0625C21.0625 9.9375 21.125 9.79167 21.125 9.625C21.125 9.45833 21.0625 9.3125 20.9375 9.1875C20.8125 9.0625 20.6667 9 20.5 9C20.3333 9 20.1875 9.0625 20.0625 9.1875C19.9375 9.3125 19.875 9.45833 19.875 9.625C19.875 9.79167 19.9375 9.9375 20.0625 10.0625C20.1875 10.1875 20.3333 10.25 20.5 10.25ZM6.125 20.25C6.64583 20.25 7.08833 20.0675 7.4525 19.7025C7.8175 19.3383 8 18.8958 8 18.375C8 17.8542 7.8175 17.4117 7.4525 17.0475C7.08833 16.6825 6.64583 16.5 6.125 16.5C5.60417 16.5 5.16167 16.6825 4.7975 17.0475C4.4325 17.4117 4.25 17.8542 4.25 18.375C4.25 18.8958 4.4325 19.3383 4.7975 19.7025C5.16167 20.0675 5.60417 20.25 6.125 20.25ZM14.875 20.25C15.3958 20.25 15.8383 20.0675 16.2025 19.7025C16.5675 19.3383 16.75 18.8958 16.75 18.375C16.75 17.8542 16.5675 17.4117 16.2025 17.0475C15.8383 16.6825 15.3958 16.5 14.875 16.5C14.3542 16.5 13.9117 16.6825 13.5475 17.0475C13.1825 17.4117 13 17.8542 13 18.375C13 18.8958 13.1825 19.3383 13.5475 19.7025C13.9117 20.0675 14.3542 20.25 14.875 20.25ZM3 26.5C2.64583 26.5 2.34917 26.38 2.11 26.14C1.87 25.9008 1.75 25.6042 1.75 25.25V22.6875C1.375 22.2708 1.07292 21.8071 0.84375 21.2962C0.614583 20.7862 0.5 20.2292 0.5 19.625V7.75C0.5 7.125 0.62 6.49458 0.86 5.85875C1.09917 5.22375 1.63 4.65625 2.4525 4.15625C3.27583 3.65625 4.48958 3.27583 6.09375 3.015C7.69792 2.755 9.85417 2.6875 12.5625 2.8125C12.2083 3.8125 11.9896 4.83333 11.9062 5.875C11.8229 6.91667 11.8958 7.95833 12.125 9H3V12.75H14.375C15.1667 13.5417 16.0883 14.1563 17.14 14.5938C18.1925 15.0312 19.3125 15.25 20.5 15.25V19.625C20.5 20.2292 20.3854 20.7862 20.1562 21.2962C19.9271 21.8071 19.625 22.2708 19.25 22.6875V25.25C19.25 25.6042 19.13 25.9008 18.89 26.14C18.6508 26.38 18.3542 26.5 18 26.5H16.75C16.3958 26.5 16.0992 26.38 15.86 26.14C15.62 25.9008 15.5 25.6042 15.5 25.25V24H5.5V25.25C5.5 25.6042 5.38042 25.9008 5.14125 26.14C4.90125 26.38 4.60417 26.5 4.25 26.5H3Z" />
                </svg>
              </ListItemIcon>
              <ListItemText
                className="menuText"
                primary="Incident Management"
              />
              {incident ? (
                <IconExpandLess className="menuIcon" />
              ) : (
                <IconExpandMore className="menuIcon" />
              )}
            </ListItem>
          )}
        <Collapse in={incident} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" disablePadding>
            {checkPrivileges([149, 150, 151, 12]) && (
              <ListItem
                button
                className={
                  activeClass?.active === CASES
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(CASES)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="View Cases"
                />
              </ListItem>
            )}
            {checkPrivileges([150, 151, 12]) && (
              <ListItem
                button
                className={
                  activeClass?.active === ADDCASE
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => {
                  if (InactiveClient()) return;
                  onRouteChange(ADDCASE);
                }}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="Add Case"
                />
              </ListItem>
            )}

            {checkPrivileges([12, 1, 2, 3]) && (
              <ListItem
                button
                className={
                  activeClass?.active === INCIDENT_LIST
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(INCIDENT_LIST)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="View Incidents"
                />
              </ListItem>
            )}
          </List>
        </Collapse>

        {/*OSHA Management*/}
        {showMenu?.isSafety && checkPrivileges([12, 152, 153, 154]) && (
          <>
            <ListItem
              button
              onClick={() =>
                handleProtectedToggle(oshaManagement, setOshaManagement)
              }
              className={"menuItem"}
            >
              <ListItemIcon className={"menuItemIcon"}>
                <svg
                  width="25"
                  height="26"
                  viewBox="0 0 25 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_9483_2153)">
                    <path
                      d="M36.8229 6.94404C36.6313 5.45556 36.5036 3.96709 36.5036 2.50929C35.5139 2.38545 32.8008 2.04418 31.9074 2.04418C27.7895 2.04418 24.8533 4.43208 24.8533 8.46364C24.8533 15.9375 34.2372 14.2319 34.2372 19.721C34.2372 21.9228 32.4817 23.2564 30.3112 23.2564C27.2789 23.2564 25.7468 20.9615 25.3639 18.3256L24.47 18.5115C24.6297 20.093 24.8533 21.6438 25.0125 23.2253C26.5767 24.0007 28.3004 24.621 30.088 24.621C34.1735 24.621 37.8124 22.3878 37.8124 18.1085C37.8124 10.6654 28.2367 12.2162 28.2367 7.06821C28.2367 4.61794 29.6412 3.16071 32.1624 3.16071C34.365 3.16071 35.7058 5.0835 35.9289 7.09922"
                      fill="#1A446F"
                    />
                    <path
                      d="M7.01461 9.51319C8.18779 7.93886 10.0951 6.91482 12.2484 6.91482C15.815 6.91482 18.7061 9.72366 18.7061 13.189C18.7061 16.6541 15.815 19.4629 12.2484 19.4629C9.60849 19.4629 7.33859 17.924 6.3374 15.7187C7.14161 16.6168 8.32647 17.1843 9.64805 17.1843C12.0709 17.1843 14.0349 15.2761 14.0349 12.9221C14.0349 10.5681 12.071 8.66006 9.64805 8.66006C8.65993 8.66006 7.74815 8.97774 7.01461 9.51319Z"
                      fill="#1A446F"
                    />
                    <path
                      d="M0.5 13.1641C0.5 8.2635 4.58895 4.2906 9.63316 4.2906C12.918 4.2906 15.7979 5.97573 17.4073 8.50477C16.1187 7.16574 14.2841 6.32891 12.2484 6.32891C8.34906 6.32891 5.18774 9.40026 5.18774 13.1891C5.18774 16.9779 8.34906 20.0493 12.2484 20.0493C14.2341 20.0493 16.0283 19.253 17.3111 17.9711C15.6853 20.418 12.8538 22.0377 9.63304 22.0377C4.58895 22.0376 0.5 18.0649 0.5 13.1641Z"
                      fill="#1A446F"
                    />
                    <path
                      d="M1.17505 8.43869C3.03539 4.37073 7.2304 1.53391 12.1077 1.53391C18.7114 1.53391 24.0649 6.73503 24.0649 13.1512C24.0649 19.5676 18.7114 24.769 12.1077 24.769C7.27585 24.769 3.11323 21.9843 1.22744 17.9771C2.92469 20.7691 6.05375 22.6419 9.63319 22.6419C15.0208 22.6419 19.3883 18.3985 19.3883 13.1643C19.3883 7.92954 15.0208 3.68638 9.63319 3.68638C6.01662 3.68638 2.85958 5.59816 1.17505 8.43869Z"
                      fill="#1A446F"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_9483_2153">
                      <rect
                        width="24"
                        height="24.7742"
                        fill="white"
                        transform="translate(0.5 0.73941)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </ListItemIcon>
              <ListItemText className="menuText" primary="OSHA Management" />
              {oshaManagement ? (
                <IconExpandLess className="menuIcon" />
              ) : (
                <IconExpandMore className="menuIcon" />
              )}
            </ListItem>

            <Collapse in={oshaManagement} timeout="auto" unmountOnExit>
              <Divider />
              <List component="div" disablePadding>
                <>
                  <ListItem
                    button
                    className={
                      activeClass?.active === OSHA_RECORDKEEPING ||
                      activeClass?.active === OSHA_ITASUBMISSION
                        ? "menuItem activeClass"
                        : "menuItem"
                    }
                    onClick={() => onRouteChange(OSHA_RECORDKEEPING)}
                  >
                    <ListItemText
                      className="menuSubText innerSubMenuText"
                      inset
                      primary="OSHA Recordkeeping"
                    />
                  </ListItem>
                  {/* <ListItem
                    button
                    className={
                      activeClass?.active === OSHA_ITASUBMISSION
                        ? "menuItem activeClass"
                        : "menuItem"
                    }
                    onClick={() => onRouteChange(OSHA_ITASUBMISSION)}
                  >
                    <ListItemText
                      className="menuSubText innerSubMenuText"
                      inset
                      primary="OSHA ITA Submission"
                    />
                  </ListItem> */}
                  <ListItem
                    button
                    className={
                      activeClass?.active === OSHA_VIEW_REPORT_LIST
                        ? "menuItem activeClass"
                        : "menuItem"
                    }
                    onClick={() => onRouteChange(OSHA_VIEW_REPORT_LIST)}
                  >
                    <ListItemText
                      className="menuSubText innerSubMenuText"
                      inset
                      primary="Historical OSHA Records"
                    />
                  </ListItem>
                </>
              </List>
            </Collapse>
          </>
        )}

        {/*SW Item Management */}
        {showMenu?.isSW && checkPrivileges([12, 105, 106, 107]) && (
          <ListItem
            button
            className={
              activeClass?.active === SW_OPEN_ITEMS
                ? "menuItem activeClass"
                : "menuItem"
            }
            onClick={() => onRouteChange(SW_OPEN_ITEMS)}
          >
            <ListItemIcon className={"menuItemIcon"}>
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10.5 8H20.5V5.5H10.5V8ZM10.5 11.75H20.5V9.25H10.5V11.75ZM10.5 15.5H16.75V13H10.5V15.5ZM6.75 8C7.10417 8 7.40125 7.88042 7.64125 7.64125C7.88042 7.40125 8 7.10417 8 6.75C8 6.39583 7.88042 6.09875 7.64125 5.85875C7.40125 5.61958 7.10417 5.5 6.75 5.5C6.39583 5.5 6.09875 5.61958 5.85875 5.85875C5.61958 6.09875 5.5 6.39583 5.5 6.75C5.5 7.10417 5.61958 7.40125 5.85875 7.64125C6.09875 7.88042 6.39583 8 6.75 8ZM6.75 11.75C7.10417 11.75 7.40125 11.63 7.64125 11.39C7.88042 11.1508 8 10.8542 8 10.5C8 10.1458 7.88042 9.84875 7.64125 9.60875C7.40125 9.36958 7.10417 9.25 6.75 9.25C6.39583 9.25 6.09875 9.36958 5.85875 9.60875C5.61958 9.84875 5.5 10.1458 5.5 10.5C5.5 10.8542 5.61958 11.1508 5.85875 11.39C6.09875 11.63 6.39583 11.75 6.75 11.75ZM6.75 15.5C7.10417 15.5 7.40125 15.38 7.64125 15.14C7.88042 14.9008 8 14.6042 8 14.25C8 13.8958 7.88042 13.5987 7.64125 13.3587C7.40125 13.1196 7.10417 13 6.75 13C6.39583 13 6.09875 13.1196 5.85875 13.3587C5.61958 13.5987 5.5 13.8958 5.5 14.25C5.5 14.6042 5.61958 14.9008 5.85875 15.14C6.09875 15.38 6.39583 15.5 6.75 15.5ZM0.5 25.5V3C0.5 2.3125 0.745 1.72375 1.235 1.23375C1.72417 0.744583 2.3125 0.5 3 0.5H23C23.6875 0.5 24.2763 0.744583 24.7663 1.23375C25.2554 1.72375 25.5 2.3125 25.5 3V18C25.5 18.6875 25.2554 19.2763 24.7663 19.7663C24.2763 20.2554 23.6875 20.5 23 20.5H5.5L0.5 25.5Z" />
              </svg>
            </ListItemIcon>
            <ListItemText className="menuText" primary="Item Management" />
          </ListItem>
        )}

        {/* Item management */}
        {showMenu?.isSafety &&
          checkPrivileges([12, 81, 82, 83, 84, 85, 86, 117, 118, 119]) && (
            <>
              <ListItem
                button
                onClick={() => handleProtectedToggle(openItem, setOpenItem)}
                className={"menuItem"}
              >
                <ListItemIcon className={"menuItemIcon"}>
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.5 8H20.5V5.5H10.5V8ZM10.5 11.75H20.5V9.25H10.5V11.75ZM10.5 15.5H16.75V13H10.5V15.5ZM6.75 8C7.10417 8 7.40125 7.88042 7.64125 7.64125C7.88042 7.40125 8 7.10417 8 6.75C8 6.39583 7.88042 6.09875 7.64125 5.85875C7.40125 5.61958 7.10417 5.5 6.75 5.5C6.39583 5.5 6.09875 5.61958 5.85875 5.85875C5.61958 6.09875 5.5 6.39583 5.5 6.75C5.5 7.10417 5.61958 7.40125 5.85875 7.64125C6.09875 7.88042 6.39583 8 6.75 8ZM6.75 11.75C7.10417 11.75 7.40125 11.63 7.64125 11.39C7.88042 11.1508 8 10.8542 8 10.5C8 10.1458 7.88042 9.84875 7.64125 9.60875C7.40125 9.36958 7.10417 9.25 6.75 9.25C6.39583 9.25 6.09875 9.36958 5.85875 9.60875C5.61958 9.84875 5.5 10.1458 5.5 10.5C5.5 10.8542 5.61958 11.1508 5.85875 11.39C6.09875 11.63 6.39583 11.75 6.75 11.75ZM6.75 15.5C7.10417 15.5 7.40125 15.38 7.64125 15.14C7.88042 14.9008 8 14.6042 8 14.25C8 13.8958 7.88042 13.5987 7.64125 13.3587C7.40125 13.1196 7.10417 13 6.75 13C6.39583 13 6.09875 13.1196 5.85875 13.3587C5.61958 13.5987 5.5 13.8958 5.5 14.25C5.5 14.6042 5.61958 14.9008 5.85875 15.14C6.09875 15.38 6.39583 15.5 6.75 15.5ZM0.5 25.5V3C0.5 2.3125 0.745 1.72375 1.235 1.23375C1.72417 0.744583 2.3125 0.5 3 0.5H23C23.6875 0.5 24.2763 0.744583 24.7663 1.23375C25.2554 1.72375 25.5 2.3125 25.5 3V18C25.5 18.6875 25.2554 19.2763 24.7663 19.7663C24.2763 20.2554 23.6875 20.5 23 20.5H5.5L0.5 25.5Z" />
                  </svg>
                </ListItemIcon>
                <ListItemText className="menuText" primary="Item Management" />
                {openItem ? (
                  <IconExpandLess className="menuIcon" />
                ) : (
                  <IconExpandMore className="menuIcon" />
                )}
              </ListItem>

              <Collapse in={openItem} timeout="auto" unmountOnExit>
                <Divider />
                <List component="div" disablePadding>
                  {checkPrivileges([12, 117, 118, 119]) && (
                    <ListItem
                      button
                      className={
                        activeClass?.active === OPEN_ITEMS_LIST
                          ? "menuItem activeClass"
                          : "menuItem"
                      }
                      onClick={() => onRouteChange(OPEN_ITEMS_LIST)}
                    >
                      <ListItemText
                        className="menuSubText"
                        inset
                        primary="View Open Items"
                      />
                    </ListItem>
                  )}
                  {checkPrivileges([12, 84, 85]) && (
                    <ListItem
                      button
                      className={
                        activeClass?.active === OBSERVATION
                          ? "menuItem activeClass"
                          : "menuItem"
                      }
                      onClick={() => {
                        if (InactiveClient()) return;
                        onRouteChange(OBSERVATION);
                      }}
                    >
                      <ListItemText
                        className="menuSubText"
                        inset
                        primary="Add Observations"
                      />
                    </ListItem>
                  )}
                  {checkPrivileges([12, 84, 85, 86]) && (
                    <ListItem
                      button
                      className={
                        activeClass?.active === VIEW_OBSERVATION_LISTS
                          ? "menuItem activeClass"
                          : "menuItem"
                      }
                      onClick={() => onRouteChange(VIEW_OBSERVATION_LISTS)}
                    >
                      <ListItemText
                        className="menuSubText"
                        inset
                        primary="View Observations"
                      />
                    </ListItem>
                  )}
                  {checkPrivileges([12, 81, 82]) && (
                    <ListItem
                      button
                      className={
                        activeClass?.active === REPRIMAND
                          ? "menuItem activeClass"
                          : "menuItem"
                      }
                      onClick={() => {
                        if (InactiveClient()) return;
                        onRouteChange(REPRIMAND);
                      }}
                    >
                      <ListItemText
                        className="menuSubText"
                        inset
                        primary="Add Reprimand"
                      />
                    </ListItem>
                  )}
                  {checkPrivileges([12, 81, 82, 83]) && (
                    <ListItem
                      button
                      className={
                        activeClass?.active === REPRIMAND_LIST
                          ? "menuItem activeClass"
                          : "menuItem"
                      }
                      onClick={() => onRouteChange(REPRIMAND_LIST)}
                    >
                      <ListItemText
                        className="menuSubText"
                        inset
                        primary="View Reprimand"
                      />
                    </ListItem>
                  )}
                </List>
              </Collapse>
            </>
          )}

        {/* Resource Library */}
        {checkPrivileges([73, 74, 75, 12]) && (
          <ListItem
            button
            className={
              activeClass?.active === ADMIN_RESOURCE
                ? "menuItem activeClass"
                : "menuItem"
            }
            onClick={() => onRouteChange(ADMIN_RESOURCE)}
          >
            <ListItemIcon className={"menuItemIcon"}>
              <NoteIcon />
            </ListItemIcon>
            <ListItemText className="menuText" primary="Resource Library" />
          </ListItem>
        )}

        {/* Learning Management */}
        {checkPrivileges([12, 9, 10, 11, 90, 91, 92]) && (
          <ListItem
            button
            className={"menuItem"}
            onClick={() => handleProtectedToggle(training, setTraining)}
          >
            <ListItemIcon className={"menuItemIcon"}>
              <svg
                width="24"
                height="28"
                viewBox="0 0 24 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 27.125C10.5 25.7083 8.78125 24.625 6.84375 23.875C4.90625 23.125 2.875 22.75 0.75 22.75V9C2.85417 9 4.875 9.38 6.8125 10.14C8.75 10.9008 10.4792 12 12 13.4375C13.5208 12 15.25 10.9008 17.1875 10.14C19.125 9.38 21.1458 9 23.25 9V22.75C21.1042 22.75 19.0679 23.125 17.1413 23.875C15.2138 24.625 13.5 25.7083 12 27.125ZM12 10.25C10.625 10.25 9.44792 9.76042 8.46875 8.78125C7.48958 7.80208 7 6.625 7 5.25C7 3.875 7.48958 2.69792 8.46875 1.71875C9.44792 0.739583 10.625 0.25 12 0.25C13.375 0.25 14.5521 0.739583 15.5312 1.71875C16.5104 2.69792 17 3.875 17 5.25C17 6.625 16.5104 7.80208 15.5312 8.78125C14.5521 9.76042 13.375 10.25 12 10.25Z" />
              </svg>
            </ListItemIcon>
            <ListItemText className="menuText" primary="Learning Management" />
            {training ? (
              <IconExpandLess className="menuIcon" />
            ) : (
              <IconExpandMore className="menuIcon" />
            )}
          </ListItem>
        )}
        <Collapse in={training} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" disablePadding>
            {checkPrivileges([12, 11]) && (
              <ListItem
                button
                className={
                  activeClass?.active === CREATE_LESSON
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => {
                  if (InactiveClient()) return;
                  onRouteChange(CREATE_LESSON);
                }}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="Create Lesson"
                />
              </ListItem>
            )}
            {checkPrivileges([12, 11]) && (
              <ListItem
                button
                className={
                  activeClass?.active === CREATE_COURSE
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => {
                  if (InactiveClient()) return;
                  onRouteChange(CREATE_COURSE);
                }}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="Create Course"
                />
              </ListItem>
            )}
            {checkPrivileges([12, 10, 11]) && (
              <ListItem
                button
                className={
                  activeClass?.active === LESSON
                    ? "menuItem activeClass"
                    : "menuItem"
                }
              >
                <ListItemText
                  inset
                  className="menuSubText"
                  primary="Training Management"
                  onClick={() => onRouteChange(LESSON)}
                />
              </ListItem>
            )}
            {checkPrivileges([12, 9, 10, 11]) && (
              <ListItem
                button
                className={
                  activeClass?.active === USERLESSON
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(USERLESSON)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="My Training"
                />
              </ListItem>
            )}
            {checkPrivileges([12, 9, 10, 11]) && (
              <ListItem
                button
                className={
                  activeClass?.active === LMS_MARKET
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(LMS_MARKET)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="Learning Marketplace"
                />
              </ListItem>
            )}
            {showMenu?.isSafety && checkPrivileges([12, 90]) && (
              <ListItem
                button
                className={
                  activeClass?.active === TOOL_BOX_LIST
                    ? "menuItem activeClass"
                    : "menuItem"
                }
              >
                <ListItemText
                  inset
                  className="menuSubText"
                  primary="Safety Meeting Management"
                  onClick={() => onRouteChange(TOOL_BOX_LIST)}
                />
              </ListItem>
            )}
            {showMenu?.isSafety && checkPrivileges([12, 90, 91]) && (
              <ListItem
                button
                className={
                  activeClass?.active === TOOL_BOX_USER
                    ? "menuItem activeClass"
                    : "menuItem"
                }
                onClick={() => onRouteChange(TOOL_BOX_USER)}
              >
                <ListItemText
                  className="menuSubText"
                  inset
                  primary="My Safety Meetings"
                />
              </ListItem>
            )}
          </List>
        </Collapse>

        {/* Safetylog */}
        {showMenu?.isSafety && checkPrivileges([12, 135]) && (
          <ListItem
            button
            className={
              activeClass?.active === ADMIN_SAFETY_LOG
                ? "menuItem activeClass"
                : "menuItem"
            }
            onClick={() => onRouteChange(ADMIN_SAFETY_LOG)}
          >
            <ListItemIcon className={"menuItemIcon"}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5.75 18.25H8.25V9.5H5.75V18.25ZM10.75 18.25H13.25V5.75H10.75V18.25ZM15.75 18.25H18.25V13.25H15.75V18.25ZM3.25 23.25C2.5625 23.25 1.97375 23.0054 1.48375 22.5163C0.994583 22.0263 0.75 21.4375 0.75 20.75V3.25C0.75 2.5625 0.994583 1.97375 1.48375 1.48375C1.97375 0.994583 2.5625 0.75 3.25 0.75H20.75C21.4375 0.75 22.0263 0.994583 22.5163 1.48375C23.0054 1.97375 23.25 2.5625 23.25 3.25V20.75C23.25 21.4375 23.0054 22.0263 22.5163 22.5163C22.0263 23.0054 21.4375 23.25 20.75 23.25H3.25Z" />
              </svg>
            </ListItemIcon>
            <ListItemText className="menuText" primary="Safety Log" />
          </ListItem>
        )}

        {/* Reports & Analytics */}
        {showMenu?.isSafety && checkPrivileges([12, 114, 115, 116]) && (
          <ListItem
            button
            className={
              activeClass?.active === REPORTS_ANALYTICS_DASHBOARD
                ? "menuItem activeClass"
                : "menuItem"
            }
            onClick={() => onRouteChange(REPORTS_ANALYTICS_DASHBOARD)}
          >
            <ListItemIcon className={"menuItemIcon"}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5.75 18.25H8.25V9.5H5.75V18.25ZM10.75 18.25H13.25V5.75H10.75V18.25ZM15.75 18.25H18.25V13.25H15.75V18.25ZM3.25 23.25C2.5625 23.25 1.97375 23.0054 1.48375 22.5163C0.994583 22.0263 0.75 21.4375 0.75 20.75V3.25C0.75 2.5625 0.994583 1.97375 1.48375 1.48375C1.97375 0.994583 2.5625 0.75 3.25 0.75H20.75C21.4375 0.75 22.0263 0.994583 22.5163 1.48375C23.0054 1.97375 23.25 2.5625 23.25 3.25V20.75C23.25 21.4375 23.0054 22.0263 22.5163 22.5163C22.0263 23.0054 21.4375 23.25 20.75 23.25H3.25Z" />
              </svg>
            </ListItemIcon>
            <ListItemText className="menuText" primary="Reports & Analytics" />
          </ListItem>
        )}

        {showMenu?.isSW && checkPrivileges([12, 142]) && (
          <ListItem
            button
            className={
              activeClass?.active === SW_REPORTS_ANALYTICS
                ? "menuItem activeClass"
                : "menuItem"
            }
            onClick={() => onRouteChange(SW_REPORTS_ANALYTICS)}
          >
            <ListItemIcon className={"menuItemIcon"}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5.75 18.25H8.25V9.5H5.75V18.25ZM10.75 18.25H13.25V5.75H10.75V18.25ZM15.75 18.25H18.25V13.25H15.75V18.25ZM3.25 23.25C2.5625 23.25 1.97375 23.0054 1.48375 22.5163C0.994583 22.0263 0.75 21.4375 0.75 20.75V3.25C0.75 2.5625 0.994583 1.97375 1.48375 1.48375C1.97375 0.994583 2.5625 0.75 3.25 0.75H20.75C21.4375 0.75 22.0263 0.994583 22.5163 1.48375C23.0054 1.97375 23.25 2.5625 23.25 3.25V20.75C23.25 21.4375 23.0054 22.0263 22.5163 22.5163C22.0263 23.0054 21.4375 23.25 20.75 23.25H3.25Z" />
              </svg>
            </ListItemIcon>
            <ListItemText className="menuText" primary="Reports & Analytics" />
          </ListItem>
        )}

        {/* Support */}
        <ListItem
          button
          className={
            activeClass?.active === SUPPORT
              ? "menuItem activeClass"
              : "menuItem"
          }
          onClick={() => onRouteChange(SUPPORT)}
        >
          <ListItemIcon className={"menuItemIcon"}>
            <svg
              width="24"
              height="27"
              viewBox="0 0 24 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M12 26.75L8.25 23H3.25C2.5625 23 1.97375 22.7554 1.48375 22.2663C0.994583 21.7763 0.75 21.1875 0.75 20.5V3C0.75 2.3125 0.994583 1.72375 1.48375 1.23375C1.97375 0.744583 2.5625 0.5 3.25 0.5H20.75C21.4375 0.5 22.0263 0.744583 22.5163 1.23375C23.0054 1.72375 23.25 2.3125 23.25 3V20.5C23.25 21.1875 23.0054 21.7763 22.5163 22.2663C22.0263 22.7554 21.4375 23 20.75 23H15.75L12 26.75ZM13.125 14.1875C13.125 13.4375 13.2083 12.8854 13.375 12.5312C13.5417 12.1771 13.8958 11.7292 14.4375 11.1875C15.1667 10.4583 15.6825 9.84875 15.985 9.35875C16.2867 8.86958 16.4375 8.3125 16.4375 7.6875C16.4375 6.58333 16.0625 5.6925 15.3125 5.015C14.5625 4.33833 13.5521 4 12.2812 4C11.1354 4 10.1617 4.28125 9.36 4.84375C8.5575 5.40625 8 6.1875 7.6875 7.1875L9.75 8C9.89583 7.4375 10.1875 6.98417 10.625 6.64C11.0625 6.29667 11.5729 6.125 12.1562 6.125C12.7188 6.125 13.1875 6.27583 13.5625 6.5775C13.9375 6.88 14.125 7.28125 14.125 7.78125C14.125 8.13542 14.0104 8.51042 13.7812 8.90625C13.5521 9.30208 13.1667 9.73958 12.625 10.2188C11.9375 10.8229 11.4637 11.4008 11.2037 11.9525C10.9429 12.505 10.8125 13.25 10.8125 14.1875H13.125ZM11.9375 19C12.375 19 12.745 18.8492 13.0475 18.5475C13.3492 18.245 13.5 17.875 13.5 17.4375C13.5 17 13.3492 16.63 13.0475 16.3275C12.745 16.0258 12.375 15.875 11.9375 15.875C11.5 15.875 11.13 16.0258 10.8275 16.3275C10.5258 16.63 10.375 17 10.375 17.4375C10.375 17.875 10.5258 18.245 10.8275 18.5475C11.13 18.8492 11.5 19 11.9375 19Z" />
            </svg>
          </ListItemIcon>
          <ListItemText className="menuText" primary="Support" />
        </ListItem>

        {/* Contactor */}
        {userInfoDetails?.isContractor && (
          <ListItem
            button
            className={"menuItem"}
            onClick={() => onRouteChange(ADMIN_CONTRACTOR_DETAILS)}
          >
            <ListItemIcon className={"menuItemIcon"}>
              <img
                width="30px"
                height="30px"
                src={sideNavImg?.personnelcontractor}
                alt="PersonnelContractor"
              />
            </ListItemIcon>
            <ListItemText className="menuText" primary="Personnel Management" />
          </ListItem>
        )}
      </List>
    </>
  );
};

export default AppMenu;
